import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { eventOccurrenceAsMemberQueryKeys } from "./eventOccurrenceAsMemberQueryKeys";

export function useQueryCalendarEventOccurrencesAsMember({
  api,
  filters,
  enabled = true,
}: {
  api: ApiType;
  filters: Omit<
    Parameters<
      ApiType["customerOccurrenceApi"]["calendarEventOccurrences"]
    >[0]["filters"],
    "nextPageToken" | "limit"
  >;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: eventOccurrenceAsMemberQueryKeys.eventOccurrences({ filters }),
    queryFn: async () => {
      const result = [
        (
          await api.customerOccurrenceApi.calendarEventOccurrences({
            filters: {
              ...filters,
              limit: 200,
              isPublicEvent: true,
            },
          })
        ).data,
      ];
      while (result[result.length - 1].nextPageToken !== undefined) {
        result.push(
          (
            await api.customerOccurrenceApi.calendarEventOccurrences({
              filters: {
                ...filters,
                limit: 200,
                isPublicEvent: true,
                nextPageToken: result[result.length - 1].nextPageToken,
              },
            })
          ).data,
        );
      }
      return result;
    },
    enabled,
  });
}
